<template>
	<v-card>
		<v-container>
			<v-row dense :align="'center'">
				<v-icon @click.prevent="regresar">
					chevron_left
				</v-icon>
				<v-col>
					<v-container>
						<v-row no-gutters>
							<v-col>
								<div class="font-weight-bold text-wrap">
									{{ datosPaciente.Nombres }}
									{{ datosPaciente.PrimerApellido }}
									{{ datosPaciente.SegundoApellido }}
								</div>
							</v-col>
						</v-row>
						<v-row no-gutters>
							<v-col>
								<div>
									{{ datosPaciente.FechaNacimiento }}
									({{ datosPaciente.Edad }}
									años)
								</div>
								<div>
									Expediente #{{ datosPaciente.NumExp }}
								</div>
								<div>
									{{ datosPaciente.FechaActual }}
									{{ datosPaciente.Hora }}
								</div>
							</v-col>
						</v-row>
					</v-container>
				</v-col>
				<v-col :justify="'end'">
					<div class="historia-title primary--text">
						Historia Clínica
					</div>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
export default {
	props: ["datosPaciente"],
	name: "infoPaciente",
	data() {
		return {};
	},
	mounted() {},
	methods: {
		regresar() {
			this.$router.back();
		}
	}
};
</script>

<style>
.historia-title {
	text-align: right;
	padding-right: 100px;
	font-size: 40px;
}
</style>
